import React from "react";
import { CharacterSheet, Tecnica } from "../data/characterSchema";

interface Props {
  character: CharacterSheet;
  onChange: (character: CharacterSheet) => void;
}

export const Tecnicas: React.FC<Props> = ({ character, onChange }) => {
  const addTecnica = () => {
    onChange({
      ...character,
      tecnicas: [
        ...character.tecnicas,
        { nome: "", categoria: "", nivel: 1, custoPQ: 0, efeito: "" },
      ],
    });
  };

  const removeTecnica = (index: number) => {
    onChange({
      ...character,
      tecnicas: character.tecnicas.filter((_, i) => i !== index),
    });
  };

  const updateTecnica = (index: number, field: keyof Tecnica, value: any) => {
    const newTecnicas = [...character.tecnicas];
    newTecnicas[index] = { ...newTecnicas[index], [field]: value };
    onChange({ ...character, tecnicas: newTecnicas });
  };

  return (
    <div className="section">
      <h2>Técnicas Conhecidas</h2>
      <button type="button" onClick={addTecnica} className="btn-add">
        + Adicionar Técnica
      </button>
      {character.tecnicas.length > 0 && (
        <table>
          <thead>
            <tr>
              <th>Técnica</th>
              <th>Categoria</th>
              <th>Nível</th>
              <th>Custo PQ</th>
              <th>Efeito</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {character.tecnicas.map((tecnica, index) => (
              <tr key={index}>
                <td>
                  <input
                    type="text"
                    value={tecnica.nome}
                    onChange={(e) => updateTecnica(index, "nome", e.target.value)}
                    placeholder="Nome da técnica"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={tecnica.categoria}
                    onChange={(e) => updateTecnica(index, "categoria", e.target.value)}
                    placeholder="Ex: Corporal"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    value={tecnica.nivel}
                    onChange={(e) => updateTecnica(index, "nivel", parseInt(e.target.value) || 1)}
                    min="1"
                    max="5"
                  />
                </td>
                <td>
                  <input
                    type="number"
                    value={tecnica.custoPQ}
                    onChange={(e) => updateTecnica(index, "custoPQ", parseInt(e.target.value) || 0)}
                    min="0"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    value={tecnica.efeito}
                    onChange={(e) => updateTecnica(index, "efeito", e.target.value)}
                    placeholder="Descrição do efeito"
                  />
                </td>
                <td>
                  <button type="button" onClick={() => removeTecnica(index)} className="btn-remove">
                    Remover
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};
